<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="5">
          <sympton-form @emitSymptonData="createSympton" />
        </v-col>
        <v-col md="7">
          <v-card class="card--shadow">
            <sympton-list :symptons="symptons" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import SymptonForm from "@/components/sympton/SymptonForm";
import SymptonList from "@/components/sympton/SymptonList";

import { mapState } from "vuex";

export default {
  components: {
    SymptonForm,
    SymptonList,
  },
  computed: {
    ...mapState("Sympton", ["symptons"]),
  },
  methods: {
    createSympton(data) {
      this.$store.dispatch("Sympton/createSympton", data);
    },
  },
  created() {
    this.$store.dispatch("Sympton/getSymptons");
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
